export const HEADER_HEIGHT = 48;
export const FOOTER_HEIGHT = 76;
export const RIGHT_PLANE_WIDTH = 450;
